/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  BytesLike,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { Airdrop } from "../Airdrop";

export class Airdrop__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _tokenUSDC: string,
    _tokenBUMP: string,
    _merkleRoot: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Airdrop> {
    return super.deploy(
      _tokenUSDC,
      _tokenBUMP,
      _merkleRoot,
      overrides || {}
    ) as Promise<Airdrop>;
  }
  getDeployTransaction(
    _tokenUSDC: string,
    _tokenBUMP: string,
    _merkleRoot: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _tokenUSDC,
      _tokenBUMP,
      _merkleRoot,
      overrides || {}
    );
  }
  attach(address: string): Airdrop {
    return super.attach(address) as Airdrop;
  }
  connect(signer: Signer): Airdrop__factory {
    return super.connect(signer) as Airdrop__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Airdrop {
    return new Contract(address, _abi, signerOrProvider) as Airdrop;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenUSDC",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenBUMP",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_merkleRoot",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountUSDC",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountBUMP",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountUSDC",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountBUMP",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "claimArgs",
        type: "bytes[]",
      },
    ],
    name: "claimBulk",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "isClaimed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "merkleRoot",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "root",
        type: "bytes32",
      },
    ],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenBUMP",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenUSDC",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
